"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupsService = void 0;
class GroupsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns a list of group.
     * @param campaignId
     * @param page
     * @param count
     * @returns CampaignGroupsResponse
     * @throws ApiError
     */
    getGroups(campaignId, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/groups',
            query: {
                'campaignId': campaignId,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Add a campaign group
     * @param requestBody
     * @returns CampaignGroupResponse
     * @throws ApiError
     */
    createGroup(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/groups',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Groups search (filter + sort)
     * @param sort
     * @param filter
     * @param page
     * @param count
     * @returns GroupSearchResult
     * @throws ApiError
     */
    searchGroups(sort, filter, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/groups/search',
            query: {
                'sort': sort,
                'filter': filter,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Generate deployments group summary
     * @param requestBody
     * @returns DeploymentGeneratedSummaryResponse
     * @throws ApiError
     */
    generateSummaryEs(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/groups/generate-summary-es',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns a specific group by id.
     * @param id
     * @returns CampaignGroupResponse
     * @throws ApiError
     */
    getGroup(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/groups/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Delete a campaign group
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deleteGroup(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/groups/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update a campaign group
     * @param id
     * @param requestBody
     * @returns CampaignGroupResponse
     * @throws ApiError
     */
    updateGroup(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/groups/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Duplicate a groups
     * @param id
     * @param requestBody
     * @returns CampaignGroupResponse
     * @throws ApiError
     */
    duplicateGroup(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/groups/{id}/duplicate',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get publishers in the group (with pagination and query)
     * @param groupId
     * @param q
     * @param page
     * @param count
     * @returns CampaignGroupPublisherItems
     * @throws ApiError
     */
    getPublishers(groupId, q, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/groups/{groupId}/publishers',
            path: {
                'groupId': groupId,
            },
            query: {
                'q': q,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Add publishers to the group
     * @param groupId
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    addPublishers(groupId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/groups/{groupId}/publishers',
            path: {
                'groupId': groupId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete publisher from a group
     * @param groupId
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    deletePublishers(groupId, requestBody) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/groups/{groupId}/publishers',
            path: {
                'groupId': groupId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete all publisher from a group
     * @param groupId
     * @returns SuccessWithErrorsResponse
     * @throws ApiError
     */
    deletePublishersAll(groupId) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/groups/{groupId}/publishers/all',
            path: {
                'groupId': groupId,
            },
        });
    }
    /**
     * Upload to curation list of publishers (csv)
     * @param id
     * @returns PublisherUploadResponse
     * @throws ApiError
     */
    uploadPublishers(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/groups/{id}/publishers-upload',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Upload csv to override deployments
     * @param id
     * @returns PublisherUploadResponse
     * @throws ApiError
     */
    repairPublishers(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/groups/{id}/publishers-repair',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Groups column information meta data
     * @returns SearchColumnsMetadata
     * @throws ApiError
     */
    getGroupsSearchMetadata() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/groups/search/metadata',
        });
    }
    /**
     * add deliverable to group
     * @param id
     * @param requestBody
     * @returns CampaignDeliverableParam
     * @throws ApiError
     */
    addGroupDeliverable(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/groups/{id}/deliverable',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * preview the group deliverables config and pricing for a deployment given the community size and country
     * @param id
     * @param communitySize
     * @param communitySizeAttribute
     * @param country
     * @returns GroupPreviewResponse
     * @throws ApiError
     */
    preview(id, communitySize, communitySizeAttribute, country) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/groups/{id}/preview',
            path: {
                'id': id,
            },
            query: {
                'communitySize': communitySize,
                'communitySizeAttribute': communitySizeAttribute,
                'country': country,
            },
        });
    }
    /**
     * Get available and taken codes for a group
     * @param id
     * @returns AttributionPlatformsResponse
     * @throws ApiError
     */
    getGroupCodes(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/groups/{id}/codes',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Returns available group labels terms information
     * @param string
     * @param size
     * @returns SearchTermsResponse
     * @throws ApiError
     */
    getGroupsLabelsTerms(string, size) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/groups/labels/terms',
            query: {
                'string': string,
                'size': size,
            },
        });
    }
    /**
     * Returns a feedback for group by id.
     * @param id
     * @param page
     * @param count
     * @param score
     * @param commentFilter
     * @returns GroupFeedbackResult
     * @throws ApiError
     */
    getGroupFeedback(id, page, count, score, commentFilter) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/groups/feedback/{id}',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'count': count,
                'score': score,
                'commentFilter': commentFilter,
            },
        });
    }
    /**
     * acknowledge a request to generate a feedback summary for the group
     * @param id
     * @returns FeedbackSummaryHistoryItem
     * @throws ApiError
     */
    generateFeedbackSummary(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/groups/{id}/generate-feedback-summary',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Returns a reject reasons for group by id.
     * @param id
     * @param page
     * @param count
     * @param reasons
     * @returns GroupRejectReasonsResult
     * @throws ApiError
     */
    getGroupRejectReasons(id, page, count, reasons) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/groups/{id}/reject-reasons',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'count': count,
                'reasons': reasons,
            },
        });
    }
    /**
     * Update a group revenue
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    updateGroupRevenue(id) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/groups/{id}/recalc-revenue',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update all deployment revenues in a group
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    updateGroupRevenueAll(id) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/groups/{id}/recalc-revenue-deployments',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Calculate revenues on all groups updated within a recent time frame
     * @param seconds
     * @returns any Successful response
     * @throws ApiError
     */
    updateGroupsRevenueRecent(seconds) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/groups/recalc-revenues',
            query: {
                'seconds': seconds,
            },
        });
    }
    /**
     * Get group revenue(s)
     * @param id
     * @returns CampaignGroupRevenueResponse
     * @throws ApiError
     */
    getGroupRevenue(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/groups/{id}/revenues',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update deployment monitored events count
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    updateDeploymentMonitoredEvents(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/groups/{id}/recalc-monitored-events',
            path: {
                'id': id,
            },
        });
    }
}
exports.GroupsService = GroupsService;
